import React from "react";
import NavBar from "../components/homePage/navBar";
import Stores from "../components/store/Stores";

const StoresPage: React.FC = () => {
    return (
        <div>
            <NavBar />
            <Stores />
        </div>
    )
}

export default StoresPage;